import { useContext, useState } from 'react';
import FacetDataContext from '~/contexts/FacetDataContext';
import ColorSwatches from './ColorSwatches';
import FilterDrawer from '../FilterDrawer';
import type WithClassName from '../WithClassName';

type OwnProps = {
  facetKey: 'interiorColors' | 'colors';
};

function ColorFacet({ className, facetKey }: WithClassName & OwnProps) {
  const [show, setShow] = useState(false);
  const { facetData } = useContext(FacetDataContext);

  return (
    <FilterDrawer
      className={className}
      dataQa={`facet-colors-${facetKey}`}
      facetContent={facetData[facetKey]?.buckets ?? []}
      facetName={facetKey === 'colors' ? 'exterior colors' : 'interior colors'}
      show={show}
      onToggle={() => {
        setShow(!show);
      }}
    >
      <ColorSwatches filterKey={facetKey} />
    </FilterDrawer>
  );
}

export default ColorFacet;
